import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { XmlparseService } from '../xml/xmlparse.service';

import { AlertService } from "../../services/alert/alert.service";
import { Iceutility } from "../../services/iceutility";
import { IceTypes } from "../../models/icetypes";
import { LoginService } from '../../login/login.service';
import { appointment } from '../../models/schedule/appointment';

declare var require: any;

const telehealthLink = "https://icemedx.zoom.us/";

@Injectable({
  providedIn: 'root'
})
export class ScheduleService extends XmlparseService  {

  constructor(private http: HttpClient, private alertSvc: AlertService, private loginSvc: LoginService) {
    super(alertSvc, loginSvc);
  }

  static getAppointmentTypes(): any[] {
    let types = [];
    try {
      // Only return the supported types
      types.push({ value: IceTypes.appt_type.appttypeInitial, name: ScheduleService.getAppointmentType(IceTypes.appt_type.appttypeInitial) });
      types.push({ value: IceTypes.appt_type.appttypeFollowup, name: ScheduleService.getAppointmentType(IceTypes.appt_type.appttypeFollowup) });
      types.push({ value: IceTypes.appt_type.appttypeOther, name: ScheduleService.getAppointmentType(IceTypes.appt_type.appttypeOther) });
      types.push({ value: IceTypes.appt_type.appttypeClosed, name: ScheduleService.getAppointmentType(IceTypes.appt_type.appttypeClosed) });
      types.push({ value: IceTypes.appt_type.appttypeUnAvailable, name: ScheduleService.getAppointmentType(IceTypes.appt_type.appttypeUnAvailable) });
    } catch (e) {
      console.log(e);
    }
    return types;
  }

  static getAppointmentType(type: IceTypes.appt_type): string {
    switch (<IceTypes.appt_type>Iceutility.toLong(type)) {
      case IceTypes.appt_type.appttypeInitial:
        return "Initial";
      case IceTypes.appt_type.appttypeFollowup:
        return "Follow-up";
      case IceTypes.appt_type.appttypeOther:
        return "Other";
      case IceTypes.appt_type.appttypeClosed:
        return "Closed";
      case IceTypes.appt_type.appttypeUnAvailable:
        return "UnAvailable";
    }
    return "";
  }

  static getRecurringTypes(): any {
    let types = [];
    try {
      // Only return the supported types
      types.push({ value: IceTypes.recurringtype.recurtypeContinuous.toString(), name: ScheduleService.getRecurringType(IceTypes.recurringtype.recurtypeContinuous) });
      types.push({ value: IceTypes.recurringtype.recurtypeOneTime.toString(), name: ScheduleService.getRecurringType(IceTypes.recurringtype.recurtypeOneTime) });
    } catch (e) {
      console.log(e);
    }
    return types;
  }

  static getRecurringType(type: any): string {
    switch (<IceTypes.recurringtype>Iceutility.toLong(type)) {
      case IceTypes.recurringtype.recurtypeContinuous:
        return "Continuous Updates";
      case IceTypes.recurringtype.recurtypeOneTime:
        return "One-Time";
      case IceTypes.recurringtype.recurtypeHourly:
        return "Hourly";
      case IceTypes.recurringtype.recurtypeDaily:
        return "Daily";
      case IceTypes.recurringtype.recurtypeWeekly:
        return "Weekly";
      case IceTypes.recurringtype.recurtypeDayWeekofMonth:
        return "Day, Week of Month";
      case IceTypes.recurringtype.recurtypeMonthly:
        return "Monthly";
      case IceTypes.recurringtype.recurtypeNumberofYears:
        return "Number of Years";
      case IceTypes.recurringtype.recurtypeYearly:
        return "Yearly";
      case IceTypes.recurringtype.recurtypeDayWeekandMonthofYear:
        return "Day, Week and Month of Year";
    }
    return "";
  }

  static getApptStatuses(): any {
    let types = [];
    try {
      // Only return the supported types
      types.push({ value: IceTypes.appt_status.apptstatNone, name: ScheduleService.getApptStat(IceTypes.appt_status.apptstatNone) });
      types.push({ value: IceTypes.appt_status.apptstatCancelled, name: ScheduleService.getApptStat(IceTypes.appt_status.apptstatCancelled) });
      types.push({ value: IceTypes.appt_status.apptstatComingUp, name: ScheduleService.getApptStat(IceTypes.appt_status.apptstatComingUp) });
      types.push({ value: IceTypes.appt_status.apptstatArrived, name: ScheduleService.getApptStat(IceTypes.appt_status.apptstatArrived) });
      types.push({ value: IceTypes.appt_status.apptstatWaiting, name: ScheduleService.getApptStat(IceTypes.appt_status.apptstatWaiting) });
      types.push({ value: IceTypes.appt_status.apptstatWithStaff, name: ScheduleService.getApptStat(IceTypes.appt_status.apptstatWithStaff) });
      types.push({ value: IceTypes.appt_status.apptstatReady, name: ScheduleService.getApptStat(IceTypes.appt_status.apptstatReady) });
      types.push({ value: IceTypes.appt_status.apptstatComplete, name: ScheduleService.getApptStat(IceTypes.appt_status.apptstatComplete) });
      types.push({ value: IceTypes.appt_status.apptstatReschedule, name: ScheduleService.getApptStat(IceTypes.appt_status.apptstatReschedule) });
    } catch (e) {
      console.log(e);
    }
    return types;
  }

  static getApptStat(stype: any): string {
    switch (Iceutility.toLong(stype)) {
      case IceTypes.appt_status.apptstatNone:
        return "None";
      case IceTypes.appt_status.apptstatCancelled:
        return "Cancelled";
      case IceTypes.appt_status.apptstatComingUp:
        return "Coming Up";
      case IceTypes.appt_status.apptstatArrived:
        return "Arrived";
      case IceTypes.appt_status.apptstatWaiting:
        return "Waiting";
      case IceTypes.appt_status.apptstatWithStaff:
        return "With Staff";
      case IceTypes.appt_status.apptstatReady:
        return "Ready";
      case IceTypes.appt_status.apptstatComplete:
        return "Complete";
      case IceTypes.appt_status.apptstatReschedule:
        return "Reschedule";
    }
    return "None";
  }

  static getReturnToOfficeValue(type: string) {
    switch (Iceutility.toLong(type)) {
      case IceTypes.ReturnToOffice.rto10_Days.value:
        return IceTypes.ReturnToOffice.rto10_Days.name;
      case IceTypes.ReturnToOffice.rto2_5Days.value:
        return IceTypes.ReturnToOffice.rto2_5Days.name;
      case IceTypes.ReturnToOffice.rto6_Days.value:
        return IceTypes.ReturnToOffice.rto6_Days.name;
      case IceTypes.ReturnToOffice.rto1_Week.value:
        return IceTypes.ReturnToOffice.rto1_Week.name;
      case IceTypes.ReturnToOffice.rto10_Days.value:
        return IceTypes.ReturnToOffice.rto10_Days.name;
      case IceTypes.ReturnToOffice.rto2_Weeks.value:
        return IceTypes.ReturnToOffice.rto2_Weeks.name;
      case IceTypes.ReturnToOffice.rto3_Weeks.value:
        return IceTypes.ReturnToOffice.rto3_Weeks.name;
      case IceTypes.ReturnToOffice.rto1_Month.value:
        return IceTypes.ReturnToOffice.rto1_Month.name;
      case IceTypes.ReturnToOffice.rto2_Months.value:
        return IceTypes.ReturnToOffice.rto2_Months.name;
      case IceTypes.ReturnToOffice.rto3_Months.value:
        return IceTypes.ReturnToOffice.rto3_Months.name;
      case IceTypes.ReturnToOffice.rto4_Months.value:
        return IceTypes.ReturnToOffice.rto4_Months.name;
      case IceTypes.ReturnToOffice.rto5_Months.value:
        return IceTypes.ReturnToOffice.rto5_Months.name;
      case IceTypes.ReturnToOffice.rto6_Months.value:
        return IceTypes.ReturnToOffice.rto6_Months.name;
      case IceTypes.ReturnToOffice.rto7_Months.value:
        return IceTypes.ReturnToOffice.rto7_Months.name;
      case IceTypes.ReturnToOffice.rto8_Months.value:
        return IceTypes.ReturnToOffice.rto8_Months.name;
      case IceTypes.ReturnToOffice.rto9_Months.value:
        return IceTypes.ReturnToOffice.rto9_Months.name;
      case IceTypes.ReturnToOffice.rto10_Months.value:
        return IceTypes.ReturnToOffice.rto10_Months.name;
      case IceTypes.ReturnToOffice.rto11_Months.value:
        return IceTypes.ReturnToOffice.rto11_Months.name;
      case IceTypes.ReturnToOffice.rto1_Year.value:
        return IceTypes.ReturnToOffice.rto1_Year.name;
      case IceTypes.ReturnToOffice.rto2_Years.value:
        return IceTypes.ReturnToOffice.rto2_Years.name;
      case IceTypes.ReturnToOffice.rtoAsNeeded.value:
        return IceTypes.ReturnToOffice.rtoAsNeeded.name;
      case IceTypes.ReturnToOffice.rtoProcedure.value:
        return IceTypes.ReturnToOffice.rtoProcedure.name;
      case IceTypes.ReturnToOffice.rtoNone.value:
        return IceTypes.ReturnToOffice.rtoNone.name;
      case IceTypes.ReturnToOffice.rto6_Weeks.value:
        return IceTypes.ReturnToOffice.rto6_Weeks.name;
      case IceTypes.ReturnToOffice.rto10_Weeks.value:
        return IceTypes.ReturnToOffice.rto10_Weeks.name;
      case IceTypes.ReturnToOffice.rtoOther.value:
        return IceTypes.ReturnToOffice.rtoOther.name;
      case IceTypes.ReturnToOffice.rtoAdmit.value:
        return IceTypes.ReturnToOffice.rtoAdmit.name;
    }
  }

  public getCalendar(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, searchprovider, from, to): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Schedule service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/calendar/default.aspx?domain=" + domain + "&data=" + "summary" + "&domaintype=" + domaintype + "&subkeys=" + "searchprovider:" + searchprovider + ";from|" + from + ";to|" + to;
    return this.http.get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["CALENDAR"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  public getMeetings(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, ptact: string, from: string, to: string): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Schedule service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/calendar/default.aspx?domain=" + domain + "&data=" + "meeting_status" + "&domaintype=" + domaintype + "&subkeys=" + "patientdomain:" + ptact + ";from|" + from + ";to|" + to;
    return this.http.get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["APPOINTMENT_INDEX", "MEETING_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  appointmentInSession(start: string, end: string, status: IceTypes.appt_status): boolean {
    if (start == null || start.length == 0 || end == null || end.length == 0) return false;

    let startTime = Iceutility.isTextDateTime(start) ? Iceutility.GetLocalDate(start) : Iceutility.ConvertFromDotNetServerTime(start);
    let endTime = Iceutility.isTextDateTime(end) ? Iceutility.GetLocalDate(end) : Iceutility.ConvertFromDotNetServerTime(end);

    let now = Iceutility.GetLocalDate();
    let difference = Math.round(((startTime.getTime() - now.getTime()) / 1000) / 60);

    // Check the difference between start slot and current time
    if (difference >= 0 && (difference <= 5 && endTime >= now) &&
      status !== IceTypes.appt_status.apptstatCancelled && status !== IceTypes.appt_status.apptstatComplete) {
      return true;
    } else if (startTime <= now && endTime >= now &&
      status !== IceTypes.appt_status.apptstatCancelled && status !== IceTypes.appt_status.apptstatComplete) {
      return true;
    }
    return false;
  }

  navigateToTelehealth(urlOverride: string) {
    window.open(urlOverride != null && urlOverride.length > 0 ? urlOverride : telehealthLink, "_blank");
  }

  public getAppointment(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, apptkey: string) {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Schedule service is not configured.";
    if (domain == null || domain.length == 0) throw "Domain is required.";
    if (apptkey == null || apptkey.length == 0) throw "Appointment key is required.";

    let url = envs[currentEnv].icemedx_api + "/calendar/default.aspx?domain=" + domain + "&key=" + apptkey + "&data=appointment" + "&domaintype=" + domaintype + "&patientdomain=&subkeys=";
    return this.http.get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["APPOINTMENT"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  insertUpdateAppointment(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, ptdomain: string, appointmentdata: appointment): Observable<any> {
    if (Iceutility.isdefined(appointmentdata) == false) throw "Schedule service Insert/Update appointment has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Schedule service is not configured.";

    let url = "";
    if (appointmentdata.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
      url = envs[currentEnv].icemedx_api + "/calendar/default.aspx?domain=" + domain + "&patientdomain=" + ptdomain + "&data=appointment&subkeys=&key=&acttype=" + domaintype;
    } else {
      url = envs[currentEnv].icemedx_api + "/calendar/default.aspx?domain=" + domain + "&patientdomain=" + ptdomain + "&data=updateappointment&subkeys=&key=" + appointmentdata.appointment_key + "&acttype=" + domaintype;
    }

    let tblname = appointmentdata.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(appointmentdata) + "}";
    return this.http.post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["APPOINTMENT"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  public deleteAppointment(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, key: string): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Login service is not configured.";
    let url = envs[currentEnv].icemedx_api + "/calendar/default.aspx?domain=" + domain + "&patientdomain=" + "" + "&data=deleteappointment&subkeys=&key=" + key + "&acttype=" + domaintype;
    let data = "{}";
    return this.http.post(url, data, { responseType: 'text' }).pipe(
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error)
      ));
  }
}
